import { FCC } from '@eluve/components';
import {
  InterstitialOverlay,
  InterstitialsProvider,
} from '@eluve/interstitials';

export const InterstitialsWrapper: FCC = ({ children }) => {
  return (
    <InterstitialsProvider>
      {children}
      <InterstitialOverlay />
    </InterstitialsProvider>
  );
};
